import {
  SystemClassifierCode,
  SystemClassifierDto,
  useSystemClassifierTranslations,
} from '../systemClassifier';
import { useConfiguration } from './useConfiguration';
import { useMemo } from 'react';

export const useSystemClassifiers = <Codes extends SystemClassifierCode[]>(
  ...codes: Codes
): { [K in Codes[number]]: SystemClassifierDto } => {
  const { systemClassifiers } = useConfiguration();
  const { translateSystemClassifier } = useSystemClassifierTranslations();
  const codesString = codes.join(delimiter);

  return useMemo(
    () =>
      systemClassifiers.reduce(
        (acc, systemClassifier) =>
          codesString
            .split(delimiter)
            .includes(systemClassifier.code as Codes[number])
            ? {
                ...acc,
                [systemClassifier.code]:
                  translateSystemClassifier(systemClassifier),
              }
            : acc,
        {} as { [K in Codes[number]]: SystemClassifierDto },
      ),
    [codesString, systemClassifiers, translateSystemClassifier],
  );
};

const delimiter = '$$';
